.modal {
  user-select: none;
}

.header {
  text-align: center;
  font-size: 16px;
}

.footer {
  display: flex;
  gap: 1rem;
}

.dynamicInput {
  position: relative;
}

.commentWrapper {
  position: relative;
}

.charCount {
  position: absolute;
  right: 35px;
  font-size: 14px;
  color: #6f6f6f;
}

.fieldWithScan {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.fieldWithScan > :first-child {
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
}

.scanButton {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 49px;
  width: 49px;
  margin-top: 1.5rem;
  padding: 0;
  border: 1px solid var(--color-neutral-400, #ccc);
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: inherit;
  flex-shrink: 0;
}

.scanButton:hover {
  background-color: var(--color-neutral-50, #f5f5f5);
}

.button {
  max-height: 70px;
}

.cancel {
  flex-grow: 1;
}

.selectionList {
  width: 100%;
}

.listMessage {
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  background-color: #f5f5f5;
  color: #666;
  font-size: 14px;
  text-align: center;
}

.listError {
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  background-color: #fee;
  color: #c33;
  font-size: 14px;
  text-align: center;
  border: 1px solid #fcc;
}
